/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentsArrayResponseV3 } from '../../models/attachments-array-response-v-3';
import { KeyType } from '../../models/key-type';

export interface GetConsignorReceiptsForDeliveryNoteV3$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;
}

export function getConsignorReceiptsForDeliveryNoteV3(http: HttpClient, rootUrl: string, params: GetConsignorReceiptsForDeliveryNoteV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AttachmentsArrayResponseV3>> {
  const rb = new RequestBuilder(rootUrl, getConsignorReceiptsForDeliveryNoteV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AttachmentsArrayResponseV3>;
    })
  );
}

getConsignorReceiptsForDeliveryNoteV3.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/receipts';
